import articleQuery from '~/graphql/queries/articles/article.gql';
import type {Bericht} from '~/graphql/graphql';

export async function useArticle(slug: string | string[]) {
  const {data} = await useAsyncQuery<{ article: Bericht }>(articleQuery, {slug});

  if (!data.value) {
    showError({statusCode: 404});
  }

  return data.value!.article;
}
